import React, { useRef } from 'react';
import { joinClasses } from '../../../../Utils/className.util';
import { IScrollableDataTable } from './ScrollableDataTable';
import useScrollableDataTableFixedItems from '../../Hooks/useScrollableDataTableFixedItems';
// @ts-ignore
import styles from './ScrollableDataTable.module.scss';

const ScrollableDataTableBody = <T,>({
	columns,
	rows,
	firstColumnFixed = true,
	onRowClick,
}: IScrollableDataTable<T>): React.ReactElement => {
	const bodyRef = useRef<any>();
	const { fixedItems } = useScrollableDataTableFixedItems({
		ref: bodyRef,
		firstColumnFixed,
	});

	return (
		<tbody className={styles.tbody} ref={bodyRef}>
			{rows.map((row: any, index: number) => {
				return (
					<tr
						key={index}
						className={styles.tr}
						onClick={() => onRowClick?.(row)}>
						<>
							{fixedItems && (
								<td
									style={{
										minHeight: fixedItems[index]?.height,
										minWidth: fixedItems[index]?.width,
										maxHeight: fixedItems[index]?.height,
										maxWidth: fixedItems[index]?.width,
										height: fixedItems[index]?.height,
										width: fixedItems[index]?.width,
									}}
									className={joinClasses([styles.td, styles.fixed])}>
									{columns[0].renderItem
										? columns[0].renderItem(row)
										: row[columns[0].key]}
								</td>
							)}
						</>
						<>
							{columns.map((column, index) => (
								<td
									key={index}
									style={{
										minWidth: column.minWidth,
										maxWidth: column.maxWidth,
										backgroundColor: row[column.key]?.color ?? undefined,
									}}
									className={joinClasses([styles.td])}>
									{column.renderItem ? column.renderItem(row) : row[column.key]}
								</td>
							))}
						</>
					</tr>
				);
			})}
		</tbody>
	);
};

export default ScrollableDataTableBody;
